import React from "react";
import MarketingLayout from "../components/MarketingLayout";

export default function NotFound() {
  return (
    <MarketingLayout>
      <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "40px 24px" }}>
        <div>
          <div style={{ fontSize: 80, fontWeight: 800, color: "#0d1520", fontFamily: "'JetBrains Mono',monospace", lineHeight: 1, marginBottom: 16 }}>404</div>
          <h1 style={{ fontSize: 28, fontWeight: 800, color: "#dde6f0", marginBottom: 12, fontFamily: "'Syne',sans-serif" }}>Page not found</h1>
          <p style={{ fontSize: 15, color: "#4a5e70", marginBottom: 36, maxWidth: 380, margin: "0 auto 36px" }}>
            This page doesn't exist. You might have followed an old link, or mistyped the URL.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/" style={{ padding: "10px 24px", background: "#0c1828", border: "1px solid #1e3d66", color: "#60a5fa", borderRadius: 7, fontSize: 13, textDecoration: "none", fontWeight: 600 }}>
              ← Home
            </a>
            <a href="/app" style={{ padding: "10px 24px", background: "linear-gradient(90deg,#e8a838,#f97316)", color: "#07090f", borderRadius: 7, fontSize: 13, textDecoration: "none", fontWeight: 700 }}>
              Open App →
            </a>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
